import { gql } from '@apollo/client';
import { graphqlClient } from './utils';

export const getProjectLibrary = (projectId: number) =>
  graphqlClient.query({
    fetchPolicy: 'no-cache',
    query: gql`
      query GetProjectLibrary{
        library(projectId: ${projectId}) {
          buildings {
            id,
            city,
            state,
            countryCode
            streetAddress,
            floors {
              id,
              floorNumber,
              name,
              totalFloorUsf
              isMeasuredFromFloorplan
              spaces {
                roomName
                roomNumber
                spaceType {
                  id
                  name
                  spaceTypeCategory {
                    id
                    category
                  }
                }
                projectSpaceTypeId
                projectSpaceType{
                  clientFacingName
                }
                photos {
                  id
                  name
                  description,
                  format,
                  insertedAt
                  floor {
                    name
                  }
                  space {
                    spaceType {
                      name
                    }
                    projectSpaceTypeId
                    roomNumber
                  }
                },
                notes {
                  id,
                  insertedAt,
                  name,
                  text
                }
              }
            }
          }
        }
      }`,
  });

export const fetchBuildingNotesSpreadsheet = (
  buildingId: number,
  timezone: string,
  clientFacingNamesAreVisible: boolean
) =>
  graphqlClient.query<{ spreadsheet: { name: string; data: string } }>({
    fetchPolicy: 'no-cache',
    query: gql`
      query FetchBuildingNotesSpreadsheet(
        $buildingId: Int
        $clientFacingNamesAreVisible: Boolean
        $timezone: String
      ) {
        spreadsheet: notesSpreadsheet(
          buildingId: $buildingId
          timezone: $timezone
          showClientFacingNames: $clientFacingNamesAreVisible
        ) {
          name
          data
        }
      }
    `,
    variables: { buildingId, timezone, clientFacingNamesAreVisible },
  });
